var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    y: 0,
    width: 30,
    height: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.9,10c0,0-.1.2-.2.2-1,.8-2.2,1.2-3.3,1.8-.7.6,1.2,2.5,1.9,1.7s.8-1.4,1.2-2c.7-.8.6.2,1.2.4s.7-.2,1-.1c.8,0,1.4,1.5.8,2.1s-1.2.2-1.6.3c-1.2.4-1.2,1.5-2.1,2s-.9.2-1.3.9-.2.8-.4,1-.6.3-.8.4c-.5.2-.7,1.1-.6,1.6-.1.1-.2-.4-.2-.4-.3-.6-1.4-.7-2-.6-1.1.2-2,1.5-1.7,2.6s.8.6,1.3.5.6-.3,1-.4c.1.1-.5,1-.4,1.3.2.5,1-.5,1.1.4s-.3,1.2.6,1.4.7,0,.7.1c-.1.2-.2,0-.4,0-.5,0-.6,0-1-.3-.6-.5-1-1-1.7-1.4s-1.7-.4-2.3-.8-.7-1-1.1-1.6c-.9-1.4-2.3-2.7-1.9-4.5s1.4-1.1,1.5-2.4-1.5-2.5-3-2.1-1.4.7-2.1,1.2c-.6,0-.6-.3-.5-.8.2-.7.8-.7,1.3-1.1.7-.6,1-1.1,1.9-1.5,2-.7,3,.2,4.9.2s1.4-.1,2.1,0,2.7.6,3.4.2.8-.8,1.1-.8.3.3.5.5c.4.4.8.2,1.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3,9.4c-.2.2-.7.5-.9.6-1.1.4-1.3.1-2.2,1.1s-.4.7-.8.7-.6-.4-.7-.7c-.1-.8.5-1.1.4-1.8s-2-.9-2-1.2c.3-.2.7-.3,1.1-.3,1.8-.3,4.6-.7,6.3-.4s.5,0,.5.2-.9.8-1.1,1c-.3.2-.5.6-.7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9,21.4c0,0,.3-.1.4-.1.5,0,.9.4,1.3.6s-.1.3-.4,0-.2-.3-.3-.4-.7-.2-.9-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9,22.3c0,.2-.6.3-.7.3v-.4c0,0,.7.1.7.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNam);
export default __webpack_public_path__ + "static/media/NAM.5d749442dbf84bc228a4c14ab40cd589.svg";
export { ForwardRef as ReactComponent };